import React from 'react'
import BoutonRetourHome from './sub-components/BoutonRetourHome';
import TagManager from 'react-gtm-module';

const tagManagerArgsLoad = {
    dataLayer: {
        'event': 'eni_ConfirmationLoad'
    },
    dataLayerName: 'PageDataLayer'
}

const tagManagerArgsSuccess = {
    dataLayer: {
        'event': 'eni_ConfirmationSuccess'
    },
    dataLayerName: 'PageDataLayer'
}

const tagManagerArgsFail = {
    dataLayer: {
        'event': 'eni_ConfirmationFail'
    },
    dataLayerName: 'PageDataLayer'
}

const tagManagerArgsFailCv = {
    dataLayer: {
        'event': 'eni_ConfirmationFailCv'
    },
    dataLayerName: 'PageDataLayer'
}

const tagManagerArgsSuccessInscription = {
    dataLayer: {
        'event': 'eni_ConfirmationSuccessInscription'
    },
    dataLayerName: 'PageDataLayer'
}
const Confirmation = ({ etapeInscription }) => {
    
    switch (etapeInscription) {
        case 1: 
            TagManager.dataLayer(tagManagerArgsLoad)
            break;    
        case 11:             
            TagManager.dataLayer(tagManagerArgsFail)
            break; 
        case 2:             
            TagManager.dataLayer(tagManagerArgsSuccessInscription)
            break; 
        case 21:             
            TagManager.dataLayer(tagManagerArgsFailCv)
            break; 
        case 3: 
            TagManager.dataLayer(tagManagerArgsSuccess)
            break; 
        default:            
            TagManager.dataLayer(tagManagerArgsLoad)
            break;  
    }
    switch (etapeInscription) {
        case 1: return (
            <div>
                Inscription en cours, veuillez ne pas fermer cette page.
            </div>
        );
        case 11: return (
            <div>
                <div class="text-center mt-3 alert alert-danger" >
                    Erreur lors de l'inscription, veuillez réessayer plus tard. Nous sommes désolé de ce désagrément...
                    Le problème a été transféré à nos équipes.
                </div>
                <BoutonRetourHome/>
            </div>
        );
        case 2: return (
            <div>
                L'inscription a été réalisée avec succès. L'envoi de vos documents a débuté, veuillez ne pas fermer cette page.
            </div>
        );
        case 21: return (
            <div>
                <div class="text-center mt-3 alert alert-danger" >
                    L'inscription a été réalisée avec succès. Cependant, l'envoi de vos documents a échoué. Vous pourrez les renvoyer par mail suite à la confirmation d'inscription que vous allez recevoir.
                </div>
                
                <BoutonRetourHome/>
            </div>
            
        );
        case 3: return (
            <div>
                <div class="border-outline-green-eni d-block w-100 color-blue-dark-eni openSans py-4">
                    <div class="ms-3">
                        <h1 class="fs-16 fw-semibold mb-4">Nous vous remercions pour votre candidature qui a été enregistrée avec succès !</h1>
                        <p>
                            Elle est actuellement à l'étude par nos équipes. Nous reviendrons vers vous prochainement afin de vous tenir informé des prochaines étapes du processus de sélection.
                        </p>
                        <p>
                            Si vous n'avez pas encore transmis votre CV lors de votre inscription, nous vous invitons à l'envoyer à l'adresse suivante : <a href="mailto:postuler@eni-ecole.fr">postuler@eni-ecole.fr</a>.
                        </p>
                        <p>
                            A bientôt, <br/>
                            Le service admission ENI Ecole Informatique
                        </p>
                    </div>
                </div>
                <BoutonRetourHome/>
            </div>
        );
        default:
            return (
                <div>
                    Inscription en cours, veuillez ne pas fermer cette page.
                </div>
                )
    }
    
  
}

export default Confirmation